import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {ACTION_TYPES} from "../../../core/consts";
import {GameCenterWidgetController} from "../game-center-widget.controller";
import {GameCenterWidgetState} from "../models/game-center-widget.state";
import {runInAction} from "mobx"
import {NAVIGATION_TABS} from "../../../modules/navigation-tabs-module/navigation-tabs-module.consts";

export class GameCenterWidgetTabChangeHandler extends ActionHandler {
  type: ACTION_TYPES;
  controller: GameCenterWidgetController;
  state: GameCenterWidgetState;

  static injectables = [...ActionHandler.injectables];

  constructor() {
    super();

    this.type = ACTION_TYPES.tabChange;
  }

  async action(params) {
    runInAction(() => {
      this.state.currentIndex = params.index || NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.match;
    });
  }
}
